import React from 'react';
import Page from 'components/misc/BasePage';
import PageHead from 'components/misc/PageHead';
import { FaqItem } from 'pageContents/RewardAboutContent/RewardFaq';
import { useGetRewardFaq } from 'entity/reward/rewardHooks';
import { groupBy } from 'lodash';

const FaqList = props => {
  const { faqs, showDivider } = props;

  return (
    <div className="flex flex-col w-full gap-6">
      <div className="flex flex-col w-full gap-4">
        {faqs.map(faq => {
          return (
            <FaqItem
              key={faq.question}
              answer={faq.answer}
              question={faq.question}
            />
          );
        })}
      </div>
      {showDivider && <div className="horizontal-divider" />}
    </div>
  );
};

const RewardAbout = () => {
  const faqs = useGetRewardFaq();

  const sectionList = faqs.reduce((sections, faq) => {
    if (sections.indexOf(faq.section) === -1) {
      sections.push(faq.section);
    }
    return sections;
  }, []);

  const faqGroupBySection = groupBy(faqs, 'section');

  return (
    <Page>
      <PageHead />
      <div className="flex flex-col w-full pt-0 lg:pt-6 lg:w-[866px]">
        <div className="flex flex-col gap-4 w-full items-center">
          <div className="center-in-div p-4 w-full h-[200px] rounded bg-white">
            <div className="flex flex-col w-full items-center gap-2">
              <p className="text-base font-bold">
                Frequently Asked Questions (FAQs)
              </p>
              <p>Rewards FAQ</p>
            </div>
          </div>
          <div className="card p-6">
            <div className="flex flex-col items-center w-full gap-6">
              {sectionList.map((section, index) => {
                const showDivider = index < sectionList.length - 1;
                return (
                  <div className="flex flex-col sapce-y-3 w-full" key={section}>
                    <p className="text-base font-bold">{section}</p>
                    <FaqList
                      showDivider={showDivider}
                      faqs={faqGroupBySection[section]}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default RewardAbout;
